<a cf-link size="sm" (click)="emitBack.emit()" [class.back-btn]="previewMode === 'desktop'">
  <svg cfIcon="chevron_down" class="tw:text-blue-50 tw:rotate-90"></svg>
  {{ "back" | translate }}
</a>

<div class="row g-5">
  <div class="col-xl-6 desktop text-center">
    <div class="card h-100">
      @if (booking.with_picture) {
        @if (booking.picture; as picture) {
          <div class="tw:flex tw:items-center tw:justify-center">
            <cf-avatar
              *ngIf="booking.picture as picture"
              [src]="$any(picture.image)"
              [rounded]="$any(picture.rounded)"
              size="xl"
              class="d-flex justify-content-center mb-2"
            />
          </div>
        }
        @if (!booking.picture) {
          <cf-avatar
            [userName]="booking.organizer_name"
            size="xl"
            class="d-flex justify-content-center mb-2"
          ></cf-avatar>
        }
      }
      <h3 class="mb-2">
        {{ booking.public_title }}
      </h3>
      <cf-text>
        <cf-text-truncate [text]="booking.description ?? ''" />
      </cf-text>

      <cf-booking-information
        [day]="day"
        [time]="time"
        [timezone]="timezone"
        [duration]="duration"
        [location]="booking.location"
        class="mt-3"
      ></cf-booking-information>
    </div>
  </div>

  <div class="col-xl-6 d-flex flex-column text-center" [formGroup]="form">
    <ng-container *ngIf="!accountService.account.email || isPreview; else accountInfoTmp">
      <h3 class="d-none d-xl-block mb-3">
        {{ "booking.fill_information" | translate }}
      </h3>

      <cf-form-field class="mb-12 text-start">
        <cf-input-label weight="500" [required]="true">
          {{ "name" | translate }}
        </cf-input-label>
        <input cf-input formControlName="name" type="text" />
        <cf-input-error [error]="form.controls.name.errors">
          {{ "name" | translate }}
        </cf-input-error>
      </cf-form-field>

      <cf-form-field class="text-start">
        <cf-input-label weight="500" [required]="true">
          {{ "email" | translate }}
        </cf-input-label>
        <input cf-input formControlName="email" type="text" />
        <cf-input-error [error]="form.controls.email.errors">
          {{ "auth.email" | translate }}
        </cf-input-error>
      </cf-form-field>
    </ng-container>

    <ng-template #accountInfoTmp>
      <h3 class="d-none d-xl-block mb-3">
        {{ "booking.your_information" | translate }}
      </h3>
      <h4 class="tw:break-words mb-0">{{ accountService.account.name }}</h4>
      <cf-text size="md" weight="400">
        {{ accountService.account.email }}
      </cf-text>
    </ng-template>

    @if (booking.questions && booking.questions.length) {
      <cf-booking-questions [form]="form" [booking]="booking" [isPreview]="isPreview"></cf-booking-questions>
    }
    @if (booking.allow_add_guests) {
      <cf-booking-guests
        [email]="form.controls.email.value"
        [emails]="form.controls.additional_guests.value"
        (emitChange)="form.controls.additional_guests.setValue($event)"
        class="mt-3"
      ></cf-booking-guests>
    }

    <ng-container>
      @if (booking.paid_events) {
        <cf-booking-page-payment
          class="mt-3"
          [booking]="booking"
          [guestCount]="guestsComponent?.emails?.length ?? 0"
          [duration]="duration"
        ></cf-booking-page-payment>
      }
    </ng-container>

    <div class="action d-flex mt-auto">
      <cf-button class="d-block mt-5 w-100" color="primary" className="w-100" (click)="submit()">
        {{
          stripeAccountConnected()
            ? ("booking.schedule_and_pay_event" | translate)
            : ("booking.schedule_event" | translate)
        }}
      </cf-button>
    </div>
  </div>
</div>
